import styled from '@emotion/styled';
import { SectionTitle } from '@presentation/components';
import { responsiveFontSize } from '@presentation/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalSectionTitle = styled(SectionTitle)`
  ${responsiveFontSize(32, 4)}
  text-align: center;
`;

export const ButtonsContainer = styled.div`
  margin-top: auto;
`;
